/**
 * Created by Pankaj on 23-Sep-2019
 */

import {RomanEmpireServerDataParser} from "../RomanEmpireServerDataParser";
import {IRomanEmpireGameData} from "./IRomanEmpireServerData";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {RomanEmpireGameMode} from "../../gamemode/RomanEmpireGameMode";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";

export interface IBetLineBothWayWinData extends IBetLineWinData {
    lineStart: string
    winPosition: boolean[]
}

export class RomanEmpireParsedGameData extends SpinParsedGameData {

    private readonly _isNextGenieReSpin: boolean;
    private readonly _numberOfRespinPlayed: number;
    private readonly _walkingWildsScatterPositions: boolean[][];
    private readonly _newOverlayWilds: boolean[][];
    private readonly _wildMultipliers: number[][];
    private readonly _accumulatedRoundWin: string;
    private readonly _totalSpinWinningsMultiplied: number;
    private readonly _wildMultipliersNextSpin: number[][];
    private readonly _genieOverlayWilds: boolean[][];
    private readonly _genieSymbolTriggerPositions: boolean[][];
    private readonly _isGenieFeatureTriggered: boolean;
    private readonly _genieFeatureAwarded: string;
    private readonly _genieExtraScatter: number[];
    private readonly _genieTimesBetCoinWin: number;
    private readonly _numberOfGeniesInFS: number;
    private readonly _isRestoreState: boolean;
    private readonly _isRandomBothWaysTriggered: boolean;
    private readonly _bothWayWins: IBetLineBothWayWinData[] = [];
    private readonly _multiplierOverlays: number[][] = [];

    private readonly _goldenGeniePositionCurrent: number[];
    private readonly _goldenGeniePositionNextSpin: number[];
    private readonly _goldenGenieMultiplierNextSpin: number;
    private readonly _isNoGenieSpin: boolean;
    private readonly _reSpinsRemaining: number;


    constructor(rawData: IRomanEmpireGameData, dataParser: RomanEmpireServerDataParser) {
        super(rawData, dataParser);
        this._isNextGenieReSpin = dataParser.getIsNextGenieFreeSpin(rawData);
        this._numberOfRespinPlayed = dataParser.getNumberOfRespinPlayed(rawData);
        this._walkingWildsScatterPositions = dataParser.getOverlayWildsScatter(rawData);
        this._newOverlayWilds = dataParser.getNewOverlayWilds(rawData);
        this._wildMultipliers = dataParser.getWildMultipliers(rawData);
        this._accumulatedRoundWin = dataParser.getAccumulatedRoundWin(rawData);
        this._totalSpinWinningsMultiplied = dataParser.getTotalSpinWinningsMultiplied(rawData);
        this._wildMultipliersNextSpin = dataParser.getWildMultipliersNextSpin(rawData);

        this._genieOverlayWilds = dataParser.getGenieOverlayWilds(rawData);
        this._genieSymbolTriggerPositions = dataParser.getGenieSymbolTriggerPositions(rawData);
        this._isGenieFeatureTriggered = dataParser.isGenieFeatureTriggered(rawData);
        this._genieFeatureAwarded = dataParser.getGenieFeatureAwarded(rawData);
        this._genieExtraScatter = dataParser.getGenieExtraScatter(rawData);
        this._genieTimesBetCoinWin = dataParser.getGenieTimesBetCoinWin(rawData);
        this._numberOfGeniesInFS = dataParser.getNumberOfGeniesInFS(rawData);
        this._isRestoreState = dataParser.getIsRestoreState(rawData);
        this._bothWayWins = dataParser.getBothWayWins(rawData);
        this._isRandomBothWaysTriggered = dataParser.isRandomBothWaysTriggered(rawData);
        this._multiplierOverlays = dataParser.getMultiplierOverlays(rawData);

        this._goldenGeniePositionCurrent = dataParser.getGoldenGeniePositionCurrent(rawData);
        this._goldenGeniePositionNextSpin = dataParser.getGoldenGeniePositionNextSpin(rawData);
        this._goldenGenieMultiplierNextSpin = dataParser.getGoldenGenieMultiplierNextSpin(rawData);
        this._isNoGenieSpin = dataParser.isNoGenieSpin(rawData);
        this._reSpinsRemaining = dataParser.parseFreespinsLeft(rawData);
    }

    get genieTimesBetCoinWin(): number {
        return this._genieTimesBetCoinWin;
    }

    get genieExtraScatter(): number[] {
        return this._genieExtraScatter;
    }

    get genieFeatureAwarded(): string {
        return this._genieFeatureAwarded;
    }

    get isGenieFeatureTriggered(): boolean {
        return this._isGenieFeatureTriggered;
    }

    get genieSymbolTriggerPositions(): boolean[][] {
        return this._genieSymbolTriggerPositions;
    }

    get isNextGenieReSpin(): boolean {
        return this._isNextGenieReSpin;
    }

    get numberOfRespinPlayed(): number {
        return this._numberOfRespinPlayed;
    }

    get walkingWildsScatterPositions(): boolean [][] {
        return this._walkingWildsScatterPositions;
    }

    get newOverlayWilds(): boolean[][] {
        return this._newOverlayWilds;
    }

    get wildMultipliers(): number[][] {
        return this._wildMultipliers;
    }

    get accumulatedRoundWin(): string {
        return this._accumulatedRoundWin;
    }

    get totalSpinWinningsMultiplied(): number {
        return this._totalSpinWinningsMultiplied;
    }

    get wildMultipliersNextSpin(): number[][] {
        return this._wildMultipliersNextSpin;
    }

    get genieOverlayWilds(): boolean[][] {
        return this._genieOverlayWilds;
    }

    get numberOfGeniesInFS(): number {
        return this._numberOfGeniesInFS;
    }

    get isRestoreState(): boolean {
        return this._isRestoreState;
    }

    // to fix #49
    protected isFeatureTotalWin(): boolean {
        return (this.mode === RomanEmpireGameMode.GENIE_RESPIN);
    }

    // to fix #49
    protected isNextFeatureTotalWin(): boolean {
        return (this.nextMode === RomanEmpireGameMode.GENIE_RESPIN);
    }

    get bothWayWins(): IBetLineBothWayWinData[] {
        return this._bothWayWins;
    }

    get isRandomBothWaysTriggered(): boolean {
        return this._isRandomBothWaysTriggered;
    }

    get multiplierOverlays(): number[][] {
        return this._multiplierOverlays;
    }

    get goldenGeniePositionCurrent(): number[] {
        return this._goldenGeniePositionCurrent;
    }

    get goldenGeniePositionNextSpin(): number[] {
        return this._goldenGeniePositionNextSpin;
    }

    get goldenGenieMultiplierNextSpin(): number {
        return this._goldenGenieMultiplierNextSpin;
    }

    get reSpinsRemaining(): number {
        return this._reSpinsRemaining;
    }

    get isNoGenieSpin(): boolean {
        return this._isNoGenieSpin;
    }
}

